import * as React from "react";
import {useSnackbar} from "notistack";


const Captcha = React.forwardRef((props, ref) => {

  const {enqueueSnackbar} = useSnackbar();


  React.useEffect(() => {
    init()
  },[])

  const [inputCaptcha ,setInputCaptcha] = React.useState('')

  // Generate a random CAPTCHA string
  function generateCaptcha() {
    let captcha = "";
    let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 4; i++) {
      captcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return captcha;
  }

  // Draw the CAPTCHA image on a canvas element
  function drawCaptcha(captcha, canvas) {
    let ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = "20px Arial";
    ctx.fillText(captcha, 60, 25);
  }

  // Verify the user's response to the CAPTCHA
  function verifyCaptcha(captcha, response) {
    return captcha.toLowerCase() === response.toLowerCase();
  }

  function init() {
    let captcha = generateCaptcha();
    let canvas = document.getElementById("captchaCanvas");
    drawCaptcha(captcha, canvas);
    sessionStorage.setItem("captcha", captcha);
  }

  React.useImperativeHandle(ref, () => ({
    checkCaptcha(){
      let captcha = sessionStorage.getItem("captcha");
      if (verifyCaptcha(captcha, inputCaptcha)) {
        init();
        return true
      } else {
        enqueueSnackbar("کپچا اشتباه است! دوباره تلاش کنید.", {
          variant: 'error',
          TransitionProps: {
            direction: 'down',
          },
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top'
          }
        })
        init();
        return false
      }
    }
  }))

  return (
       <div className="captcha-component">
         <div className="row align-items-center">
           <div className="col-4 col-md-3">
             <canvas id="captchaCanvas" width="80" height="35"/>
           </div>
           <div className="col-6 col-md-7">
             <input type="text" id="captchaInput" className="m-0" placeholder="متن تصویر"
                    value={inputCaptcha}
                    onChange={(e) => setInputCaptcha(e.target.value)}/>
           </div>
           <div className="col-2 col-md-2">
             <div className="btnGroup_blue m-0 justify-content-start">
               <button className="btnFill" type="button" onClick={init}>
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" x="0" y="0" viewBox="0 0 512 512"
                      className="">
                   <g>
                     <path
                        d="M512 86.401V177.6c0 17.673-14.327 32-32 32h-91.199c-17.673 0-32-14.327-32-32s14.327-32 32-32h24.45C377.916 94.955 320.007 64 256 64c-79.639 0-149.848 47.913-178.866 122.063-6.442 16.458-25.006 24.577-41.462 18.137-16.458-6.441-24.578-25.004-18.137-41.461 18.559-47.423 50.547-87.906 92.506-117.073C153.018 15.791 203.489 0 256 0s102.982 15.791 145.959 45.665c17.076 11.87 32.501 25.616 46.041 40.94v-.203c0-17.673 14.327-32 32-32s32 14.326 32 31.999zm-35.672 221.4c-16.457-6.442-35.02 1.68-41.462 18.137C405.848 400.088 335.639 448 256 448c-62.647 0-119.454-29.654-154.97-78.4h22.169c17.673 0 32-14.327 32-32s-14.327-32-32-32H32c-17.673 0-32 14.327-32 32v91.2c0 17.673 14.327 32 32 32s32-14.327 32-32v-3.404c13.54 15.324 28.965 29.069 46.041 40.939C153.018 496.209 203.489 512 256 512s102.982-15.791 145.959-45.665c41.959-29.167 73.947-69.65 92.506-117.073 6.441-16.457-1.679-35.02-18.137-41.461z"
                        fill="#ffffff" data-original="#ffffff" className=""/>
                   </g>
                 </svg>
               </button>
             </div>
           </div>

         </div>
       </div>
  )
})


export default Captcha;
